import { convertBusinessDayToDate } from '@monolith/legacy/services/date-locale';

export const useEstimatedDate = () => {
  const getFormattedEstimatedDate = (minDays: number, maxDays: number): string => {
    const initialDate = convertBusinessDayToDate(minDays);
    const endDate = convertBusinessDayToDate(maxDays);
    if (initialDate.month === endDate.month && initialDate.day === endDate.day) {
      return `${endDate.day} ${endDate.month}`;
    } else if (initialDate.month === endDate.month) {
      return `${initialDate.day} - ${endDate.day} ${endDate.month}`;
    } else {
      return `${initialDate.day} ${initialDate.month} - ${endDate.day} ${endDate.month}`;
    }
  };

  return {
    getFormattedEstimatedDate,
  };
};
